import moment from "moment";
import { FilterStateType } from "../types";
import { UseFormReturn } from "react-hook-form";
import { FormType } from "../schemas";
import { useEffect, useState } from "react";

export function handlePreviousDateRange(params: {
    effective: FilterStateType;
    setEffective: React.Dispatch<React.SetStateAction<FilterStateType>>;
}) {
    const { effective, setEffective } = params;

    const startDate = moment(effective.date_start)
        .subtract(1, "month")
        .format("YYYY-MM-DD");

    const endDate = moment(effective.date_end)
        .subtract(1, "month")
        .format("YYYY-MM-DD");

    setEffective(prev => ({
        ...prev,
        date_start: startDate,
        date_end: endDate
    }));
}


export const handleCheckAllDate = (
    method: UseFormReturn<FormType>,
    detail: FormType["detail"],
    params: { dateIndex: number; checked: boolean }
) => {
    const { dateIndex, checked } = params;

    detail?.forEach((_, rowIndex) => {
        method.setValue(
            `detail.${rowIndex}.shift_schedule.${dateIndex}.checked`,
            checked
        );
        
    });
};

export function useEffectiveFilter(filter: FilterStateType) {
    const [effectiveFilter, setEffectiveFilter] = useState(filter);
    const [lockDateSync, setLockDateSync] = useState(false);

    useEffect(() => {
        if (!lockDateSync) {
            setEffectiveFilter(filter);
        }

    // eslint-disable-next-line
    }, [
        filter.keyword,
        filter.department,
        filter.jobpos,
        filter.location,
        filter.date_start,
        filter.date_end
    ]);

    return {
        effectiveFilter,
        setEffectiveFilter,
        lockDateSync,
        setLockDateSync
    };
}


